/*! Zio RGB ışık motoru v7.2 (2026-10-10) — tema dosyası assets/zio-rgb-isik.js, kaynak theme/src/zio-rgb-isik.js.
   Beş ayrı kopyanın (kart ışığı zk/zs/zc, düğme ışığı zb, çubuk çizgisi zd) TEK kaynağı. Bölümler bu dosyayı
   <script src="…zio-rgb-isik.js" defer> ile yükler (aynı adres bir kez indirilir; tanım bekçisi ikinci çalışmayı atlar).
   Shopify CDN dosyayı küçültür (boşluk, tırnak, sözdizimi); işçi kaynağı bu yüzden kendi içine kapalı tek bir işlevin
   (motorPaketi) metninden üretilir: adlar değişse de tutarlı kalır.

   İki özel öğe:
   <zio-rgb-light>  Kartların (ya da tek bir düğmenin) kenarında dolaşan TEK ince, kuyruklu ışık; saydam bir tuvale çizilir.
     Öznitelikler: data-kartlar   kart seçicisi, üst öğeye (parentElement) göre; varsayılan ".card-grid > .card"
                   data-turn      ortalama büyüklükteki bir kartın etrafını bir kez dönme süresi, ms (800–8000, varsayılan 3000)
                   data-tail      kuyruk uzunluğu, px (20–240, varsayılan 120)
                   data-kalinlik  çizgi/hale kalınlığı, kart ışığına göre % (30–100, varsayılan 100)
                   data-pay       tuvalin kart kutusunun dışına taşan payı, px (0–64, varsayılan 16)
     Yol: kartlar yılan sırasıyla (satırlar yukarıdan aşağı, tek satır soldan sağa, çift satır sağdan sola) gezilir; her ziyarette
     kartın yuvarlak kenarında en az bir tam tur (önceki kartın tarafından girer, sıradakinin tarafından çıkar, kısa yönden döner);
     kartlar arası geçiş karşılıklı kenarların örtüşen aralığının ORTASINDAN dik; komşuluk kenar boşluğuyla (boşluk ≤ en küçük kenarın
     yarısı ve öteki eksende örtüşme). Son kart ilk karta komşuysa halka, değilse gidiş-dönüş. Hız = ortalama kart çevresi / tur süresi,
     her yerde sabit. Eşit kartlı ızgarada bu kurallar merkez-uzaklığı/kenar-ortası kurallarıyla aynı sonucu verir (kum havuzu kanıtı).
     Kaydırma kutusu: kartlar yatay kayan bir kutunun (overflow-x auto/scroll) içindeyse tuval o kutunun görünür alanıyla kırpılır ve
     kutu kaydıkça aynı miktarda ötelenir (yalnız dönüşüm; çizim yerleşim koordinatlarında kalır). Kutu yoksa kırpma yok.
     Tek kart (düğme): tam bir tur, halka.
   <zio-rgb-cizgi>  Tam genişlikte RGB çizgi (duyuru çubuğunun kenarı): her sütunun rengi 480 px'lik gidiş-dönüş desenine göre
     hsl(140° + 150°·faz + ton kayması, %100, %50); desen sağa akar, ton 45°/sn kayar (kart ışığıyla aynı formül).
     Öznitelikler: data-kalinlik px (1–4, varsayılan 2), data-kayma desenin bir tur kayma süresi s (4–20, varsayılan 8), data-konum ust|alt.

   Ortak davranış: kurulum (ölçüm + yol + işçi) sayfa yüklendikten ve yazı tipleri geldikten sonra tarayıcı BOŞTAYKEN bir kez
   (requestIdleCallback, en çok 3 s); bölüm görününce yalnız "oynat"; görünmezken ve sekme arkadayken durur; görünür olunca 250 ms
   sonra kart kutuları doğrulanır, değiştiyse yeniden ölçülür; ResizeObserver yalnız üst öğenin ölçüsü gerçekten değişince (200 ms).
   Bu iki gecikmeli ölçüm YERLEŞİM TEMİZKEN yapılır (v7.2): süre dolunca geçici bir ResizeObserver kurulur; tarayıcı ilk bildirimi bir
   sonraki karede stil + yerleşim adımının hemen ardından, başka betik çalışmadan verir (HTML "update the rendering" sırası: rAF → stil/yerleşim →
   ResizeObserver → boyama); ölçüm orada yapılır, okumalar bekleyen stil/yerleşim hesabını zorlamaz. (10-10 kasma izleri: v7'de zamanlayıcı
   anında ölçüm 4× yavaş telefonda 118 ms'lik tek görevdi, 94 ms'i zorunlu stil + yerleşim; v7.1'in rAF → zamanlayıcı 0 yolu da aradaki
   betikler ağacı yeniden kirlettiği için 124 ms verdi.) ResizeObserver yoksa ölçüm hemen yapılır.
   Çizim: sayfadaki BÜTÜN öğeler için TEK işçi iş parçacığı (OffscreenCanvas, tek requestAnimationFrame döngüsü); işçi yoksa ya da
   bozulursa aynı motor ana iş parçacığında (data-kip isci|yerel|yok). Renk/hız her karede zamana göre hesaplanır (kare atlasa da
   hız sabit kalır); duraklat/sürdür ve yeniden ölçümde konum sürekli kalır. Hareket azaltma tercihinde hiçbir şey çizilmez.
   Öğeler tıklanmaz (pointer-events none), erişilebilirlik ağacında yok (aria-hidden bölümde verilir). */
(function () {
  'use strict';
  if (typeof window === 'undefined' || !window.customElements || customElements.get('zio-rgb-light')) return;

  var reduce = typeof window.matchMedia === 'function' ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  function mod(a, n) { return ((a % n) + n) % n; }
  function sinir(v, lo, hi, def) { v = parseFloat(v); return isNaN(v) ? def : Math.min(hi, Math.max(lo, v)); }
  function konumRoot(el, root) {
    var x = 0, y = 0, n = el;
    while (n && n !== root) { x += n.offsetLeft; y += n.offsetTop; n = n.offsetParent; }
    if (n !== root) { var a = el.getBoundingClientRect(), b = root.getBoundingClientRect(); return { x: a.left - b.left, y: a.top - b.top }; }
    return { x: x, y: y };
  }

  /* ---------- yol geometrisi (ana iş parçacığı) ---------- */
  /* Yılan sırası: satırlar yukarıdan aşağı; 1. satır soldan sağa, 2. satır sağdan sola, ... (4 px dikey tolerans) */
  function yilanSirasi(items) {
    items.sort(function (a, b) { return Math.abs(a.y - b.y) > 4 ? a.y - b.y : a.x - b.x; });
    var rows = [];
    items.forEach(function (it) { var row = rows[rows.length - 1]; if (row && Math.abs(row[0].y - it.y) <= 4) row.push(it); else rows.push([it]); });
    return rows.reduce(function (out, row, k) { return out.concat(k % 2 ? row.slice().reverse() : row); }, []);
  }
  /* Kartın kenarı: üst ortadan saat yönünde, köşeleri kartınki kadar yuvarlak (8 kirişli) kapalı çizgi; s = başlangıçtan yol uzunluğu */
  function kenar(c) {
    var x = c.x, y = c.y, w = c.w, h = c.h, r = Math.max(0, Math.min(c.r, w / 2, h / 2));
    var pts = [];
    function add(px, py) { var last = pts[pts.length - 1]; var s = last ? last.s + Math.hypot(px - last.x, py - last.y) : 0; if (last && s - last.s < 0.01) return; pts.push({ x: px, y: py, s: s }); }
    function yay(cx, cy, a0, a1) { for (var k = 1; k <= 8; k++) { var a = a0 + (a1 - a0) * k / 8; add(cx + r * Math.cos(a), cy + r * Math.sin(a)); } }
    add(x + w / 2, y);
    add(x + w - r, y); yay(x + w - r, y + r, -Math.PI / 2, 0);
    add(x + w, y + h - r); yay(x + w - r, y + h - r, 0, Math.PI / 2);
    add(x + r, y + h); yay(x + r, y + h - r, Math.PI / 2, Math.PI);
    add(x, y + r); yay(x + r, y + r, Math.PI, 1.5 * Math.PI);
    add(x + w / 2, y);
    return { pts: pts, P: pts[pts.length - 1].s };
  }
  function noktaS(k, s) {
    var p = k.pts;
    for (var i = 1; i < p.length; i++) if (s <= p[i].s) { var a = p[i - 1], b = p[i], t = (s - a.s) / ((b.s - a.s) || 1); return { x: a.x + (b.x - a.x) * t, y: a.y + (b.y - a.y) * t }; }
    return { x: p[p.length - 1].x, y: p[p.length - 1].y };
  }
  function enYakinS(k, q) {
    var p = k.pts, best = 0, bestD = Infinity;
    for (var i = 1; i < p.length; i++) {
      var a = p[i - 1], b = p[i], vx = b.x - a.x, vy = b.y - a.y, L = vx * vx + vy * vy;
      var t = L ? Math.max(0, Math.min(1, ((q.x - a.x) * vx + (q.y - a.y) * vy) / L)) : 0;
      var px = a.x + vx * t, py = a.y + vy * t, d = (px - q.x) * (px - q.x) + (py - q.y) * (py - q.y);
      if (d < bestD) { bestD = d; best = a.s + (b.s - a.s) * t; }
    }
    return mod(best, k.P);
  }
  /* İki kart arasındaki boşluk: yatay (gx) ve dikey (gy); eksi değer o eksende örtüşme demektir */
  function bosluk(a, b) { return { gx: Math.max(a.x, b.x) - Math.min(a.x + a.w, b.x + b.w), gy: Math.max(a.y, b.y) - Math.min(a.y + a.h, b.y + b.h) }; }
  /* c kartının o kartına bakan kenarındaki giriş/çıkış noktası: karşılıklı kenarların örtüşen aralığının ortası (geçiş dik);
     çapraz/üst üste kartlarda merkez hizası */
  function bakanKenar(c, o) {
    if (c === o) return { x: c.x + c.w / 2, y: c.y };
    var g = bosluk(c, o), cx = o.x + o.w / 2 - (c.x + c.w / 2), cy = o.y + o.h / 2 - (c.y + c.h / 2);
    if (g.gx >= 0 && g.gy < 0) { var y = (Math.max(c.y, o.y) + Math.min(c.y + c.h, o.y + o.h)) / 2; return cx > 0 ? { x: c.x + c.w, y: y } : { x: c.x, y: y }; }
    if (g.gy >= 0 && g.gx < 0) { var x = (Math.max(c.x, o.x) + Math.min(c.x + c.w, o.x + o.w)) / 2; return cy > 0 ? { x: x, y: c.y + c.h } : { x: x, y: c.y }; }
    if (Math.abs(cx) >= Math.abs(cy)) return cx > 0 ? { x: c.x + c.w, y: c.y + c.h / 2 } : { x: c.x, y: c.y + c.h / 2 };
    return cy > 0 ? { x: c.x + c.w / 2, y: c.y + c.h } : { x: c.x + c.w / 2, y: c.y };
  }
  /* Komşuluk kenar boşluğuyla: boşluk en küçük kenarın yarısından az ve öteki eksende kutular örtüşüyorsa komşu */
  function komsu(a, b) { var g = bosluk(a, b), lim = 0.5 * Math.min(a.w, a.h, b.w, b.h); return (g.gx >= 0 && g.gx <= lim && g.gy < 0) || (g.gy >= 0 && g.gy <= lim && g.gx < 0); }
  /* Tek yol: her ziyarette kartın kenarında en az bir tam tur (önceki kartın tarafından girer, sıradakinin tarafından çıkar, kısa yönden
     döner); ziyaretler arasında boşluk düz geçilir. Son kart ilk karta komşuysa halka, değilse gidiş-dönüş. out.sira = ziyaret sırası. */
  function yol(cards) {
    var n = cards.length, seq = [], i;
    for (i = 0; i < n; i++) seq.push(i);
    var halka = n <= 2 || komsu(cards[n - 1], cards[0]);
    if (!halka) for (i = n - 2; i >= 1; i--) seq.push(i);
    var m = seq.length, out = [];
    for (var v = 0; v < m; v++) {
      var c = cards[seq[v]], k = c.kenar, P = k.P;
      var sIn = enYakinS(k, bakanKenar(c, cards[seq[mod(v - 1, m)]]));
      var sOut = enYakinS(k, bakanKenar(c, cards[seq[mod(v + 1, m)]]));
      var cw = mod(sOut - sIn, P), ccw = mod(sIn - sOut, P);
      var dir = cw <= ccw ? 1 : -1, T = P + Math.min(cw, ccw);
      var vs = k.pts.slice(0, -1).map(function (p) { return p.s; });
      var s = sIn, gone = 0;
      out.push({ x: noktaS(k, s).x, y: noktaS(k, s).y, card: seq[v] });
      while (gone < T - 1e-6) {
        var best = Infinity;
        for (var j = 0; j < vs.length; j++) { var dd = dir > 0 ? mod(vs[j] - s, P) : mod(s - vs[j], P); if (dd > 1e-6 && dd < best) best = dd; }
        var step = Math.min(best, T - gone);
        s = mod(s + dir * step, P);
        gone += step;
        var q = noktaS(k, s);
        out.push({ x: q.x, y: q.y, card: seq[v] });
      }
    }
    out.push({ x: out[0].x, y: out[0].y, card: out[0].card });
    out.sira = seq;
    out.halka = halka;
    return out;
  }

  /* ---------- çizim motoru: KENDİ İÇİNE KAPALI paket; aynı metin işçide (OffscreenCanvas) ve yedek yolda (ana iş parçacığı) çalışır ----------
     Dışarıdan yalnız tarayıcı/işçi genel adlarını kullanır (performance, requestAnimationFrame, setTimeout, Math). Küçültücü adları
     değiştirse de işlevin metni (toString) tutarlı kalır. */
  function motorPaketi() {
    var RENK_HIZI = 45;   /* derece/sn: renkler 8 sn'de bir tam tur kayar */
    var DESEN = 480;      /* çizgi deseni uzunluğu, px: 240 px'te yeşilden mora, 240 px'te geri */
    function mod(a, n) { return ((a % n) + n) % n; }
    /* g = {pts, cum, total}; s: yol boyunca uzaklık → nokta (ikili arama) */
    function yolNokta(g, s) {
      var p = g.pts, c = g.cum, lo = 0, hi = p.length - 1;
      while (hi - lo > 1) { var m = (lo + hi) >> 1; if (c[m] <= s) lo = m; else hi = m; }
      var t = (s - c[lo]) / ((c[hi] - c[lo]) || 1);
      return { x: p[lo].x + (p[hi].x - p[lo].x) * t, y: p[lo].y + (p[hi].y - p[lo].y) * t };
    }
    /* Kuyruk: baş s konumunda, kuyruk yol boyunca geriye st.tail px; 4 px parçalar; katmanlar çekirdek (3,2 → 1 px), iç hale (+5),
       dış hale (+10), hepsi st.kalin ile çarpılır; 'destination-over' ile önce çizilen üstte kalır (bindirmede saydamlık birikmez).
       Renk: baş 140° (yeşil) → uç 290° (mor), hue0 kadar kaymış. */
    function kuyrukCiz(ctx, g, st, s, hue0) {
      var dpr = st.dpr, L = st.tail, ADIM = 4, n = Math.max(1, Math.ceil(L / ADIM)), i, kf = st.kalin || 1;
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
      ctx.setTransform(dpr, 0, 0, dpr, -st.ox * dpr, -st.oy * dpr);
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.globalCompositeOperation = 'destination-over';
      var ucs = [];
      for (i = 0; i <= n; i++) ucs.push(yolNokta(g, mod(s - Math.min(L, i * ADIM), g.total)));
      var katman = [[0, 1, 50], [5, 0.3, 55], [10, 0.12, 55]];
      for (var k = 0; k < katman.length; k++) {
        for (i = 0; i < n; i++) {
          var t = Math.min(L, i * ADIM + ADIM / 2) / L;
          ctx.strokeStyle = 'hsla(' + mod(140 + 150 * t + hue0, 360).toFixed(1) + ',100%,' + katman[k][2] + '%,' + ((1 - t) * katman[k][1]).toFixed(3) + ')';
          ctx.lineWidth = (3.2 - 2.2 * t + katman[k][0]) * kf;
          ctx.beginPath();
          ctx.moveTo(ucs[i].x, ucs[i].y);
          ctx.lineTo(ucs[i + 1].x, ucs[i + 1].y);
          ctx.stroke();
        }
      }
    }
    /* hsl(h, 100%, 50%) → [r, g, b] (kart ışığının çekirdek rengiyle aynı: en büyük kanal 255, en küçük 0) */
    function renk(h) {
      var k = mod(h, 360) / 60, s = Math.floor(k), f = 1 - Math.abs(mod(k, 2) - 1), x = Math.round(255 * f);
      return s === 0 ? [255, x, 0] : s === 1 ? [x, 255, 0] : s === 2 ? [0, 255, x] : s === 3 ? [0, x, 255] : s === 4 ? [x, 0, 255] : [255, 0, x];
    }
    /* Çizgi: her sütun için desen fazı (gidiş-dönüş 0→1→0), ton = 140° + 150°·faz + hue0; kay = desenin sağa kayması (css px);
       tek satır hesaplanır, kalan satırlara kopyalanır, tek putImageData. cep: ImageData önbelleği (motor örneğine ait). */
    function cizgiCiz(ctx, st, kay, hue0, cep) {
      var W = ctx.canvas.width, H = ctx.canvas.height, img = cep.img;
      if (!img || img.width !== W || img.height !== H) img = cep.img = ctx.createImageData(W, H);
      var d = img.data, i, u, tri, c, o;
      for (i = 0; i < W; i++) {
        u = mod(i / st.dpr - kay, DESEN) / DESEN;
        tri = u < 0.5 ? 2 * u : 2 - 2 * u;
        c = renk(140 + 150 * tri + hue0);
        o = i * 4; d[o] = c[0]; d[o + 1] = c[1]; d[o + 2] = c[2]; d[o + 3] = 255;
      }
      var satir = d.subarray(0, W * 4);
      for (var y = 1; y < H; y++) d.set(satir, y * W * 4);
      ctx.putImageData(img, 0, 0);
    }
    /* Motor: birden çok öğeyi kimlikle tutar, TEK requestAnimationFrame döngüsünde çizer. Mesajlar: kur {id, canvas, veri}, geo {id, veri},
       oynat {id}, durdur {id}, sil {id}. veri = {tip:'isik', geo, st} ya da {tip:'cizgi', st}; st.hiz (px/sn), st.periyot (px).
       Konum ve ton zamana göre; duraklat/sürdür ve yeniden ölçümde konum sürekli (sTaban/tTaban). */
    function motorKur(gonder) {
      var ogeler = {}, calisan = false;
      var raf = typeof requestAnimationFrame === 'function' ? function (f) { requestAnimationFrame(f); } : function (f) { setTimeout(function () { f(performance.now()); }, 16); };
      function simdi(o) { return o.tBirikim + (o.oynuyor ? (performance.now() - o.t0) / 1000 : 0); }
      function konum(o, t) { return mod(o.sTaban + o.veri.st.hiz * (t - o.tTaban), o.veri.st.periyot); }
      function boyut(o) { o.tuval.width = Math.max(1, Math.round(o.veri.st.w * o.veri.st.dpr)); o.tuval.height = Math.max(1, Math.round(o.veri.st.h * o.veri.st.dpr)); }
      function ciz(o, t) {
        var hue0 = mod(RENK_HIZI * t, 360), s = konum(o, t);
        if (o.veri.tip === 'cizgi') cizgiCiz(o.ctx, o.veri.st, s, hue0, o.cep); else kuyrukCiz(o.ctx, o.veri.geo, o.veri.st, s, hue0);
      }
      function dongu() {
        var herhangi = false;
        for (var id in ogeler) { var o = ogeler[id]; if (!o.oynuyor) continue; herhangi = true; ciz(o, simdi(o)); }
        calisan = herhangi;
        if (herhangi) raf(dongu);
      }
      return {
        al: function (m) {
          var o = ogeler[m.id];
          if (m.tip === 'kur') {
            var ctx = m.canvas && typeof m.canvas.getContext === 'function' ? m.canvas.getContext('2d') : null;
            if (!ctx) { gonder({ tip: 'yok', id: m.id }); return; }
            o = ogeler[m.id] = { tuval: m.canvas, ctx: ctx, veri: m.veri, cep: {}, oynuyor: false, t0: 0, tBirikim: 0, sTaban: 0, tTaban: 0 };
            boyut(o);
            ciz(o, 0);
            gonder({ tip: 'hazir', id: m.id });
          } else if (!o) {
            return;
          } else if (m.tip === 'geo') {
            var t = simdi(o);
            o.sTaban = konum(o, t); o.tTaban = t; o.veri = m.veri; o.sTaban = mod(o.sTaban, o.veri.st.periyot); o.cep = {};
            boyut(o);
            if (!o.oynuyor) ciz(o, t);
          } else if (m.tip === 'oynat') {
            if (o.oynuyor) return;
            o.oynuyor = true; o.t0 = performance.now();
            if (!calisan) { calisan = true; raf(dongu); }
          } else if (m.tip === 'durdur') {
            if (!o.oynuyor) return;
            o.tBirikim += (performance.now() - o.t0) / 1000; o.oynuyor = false;
          } else if (m.tip === 'sil') {
            delete ogeler[m.id];
          }
        }
      };
    }
    return { motorKur: motorKur, DESEN: DESEN, RENK_HIZI: RENK_HIZI };
  }
  var paket = motorPaketi();
  function isciKaynak() {
    return 'var paket = (' + motorPaketi.toString() + ')();\n'
      + 'var motor = paket.motorKur(function (m) { self.postMessage(m); });\n'
      + 'self.onmessage = function (e) { motor.al(e.data); };\n';
  }

  /* ---------- sayfa: tek paylaşımlı işçi, boşta kurulum, ortak stil ---------- */
  var isci = null, isciBozuk = false, isciUrl = null, dinleyiciler = {}, sayac = 0;
  function isciAl() {
    if (isci || isciBozuk) return isci;
    if (!(window.Worker && window.OffscreenCanvas && window.Blob && window.URL && typeof URL.createObjectURL === 'function')) { isciBozuk = true; return null; }
    try {
      isciUrl = URL.createObjectURL(new Blob([isciKaynak()], { type: 'text/javascript' }));
      var w = new Worker(isciUrl);
      w.onmessage = function (e) {
        var m = e.data || {};
        if (isciUrl) { URL.revokeObjectURL(isciUrl); isciUrl = null; }
        var el = dinleyiciler[m.id];
        if (el) el.isciMesaj(m);
      };
      w.onerror = function () {
        isciBozuk = true; isci = null;
        var hepsi = dinleyiciler; dinleyiciler = {};
        for (var id in hepsi) hepsi[id].yerel(true);
      };
      isci = w;
    } catch (e) { isciBozuk = true; isci = null; }
    return isci;
  }
  var bostaBekleyen = [], bostaHazir = false, bostaKuruldu = false;
  function bostaCalistir(f) { if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(function () { f(); }, { timeout: 3000 }); else setTimeout(f, 500); }
  /* Sayfa yüklendikten ve yazı tipleri geldikten sonra (yazı tipi kart yüksekliklerini değiştirir) boşta bir kez çağırır */
  function bostaKur(f) {
    if (bostaHazir) { bostaCalistir(f); return; }
    bostaBekleyen.push(f);
    if (bostaKuruldu) return;
    bostaKuruldu = true;
    var sonra = function () { bostaHazir = true; var l = bostaBekleyen; bostaBekleyen = []; l.forEach(bostaCalistir); };
    var yuklendi = function () { if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') document.fonts.ready.then(sonra, sonra); else sonra(); };
    if (document.readyState === 'complete') yuklendi(); else window.addEventListener('load', yuklendi, { once: true });
  }
  function stilKur() {
    if (document.getElementById('zio-rgb-isik-stil')) return;
    var st = document.createElement('style');
    st.id = 'zio-rgb-isik-stil';
    st.setAttribute('data-surum', '7');
    st.textContent = 'zio-rgb-light,zio-rgb-cizgi{position:absolute;display:block;pointer-events:none;z-index:1}'
      + 'zio-rgb-light{top:0;right:0;bottom:0;left:0;opacity:0;transition:opacity .6s ease}'
      + 'zio-rgb-light.is-on{opacity:1}'
      + 'zio-rgb-light>.zio-rgb__kirp{position:absolute;overflow:hidden;pointer-events:none}'
      + 'zio-rgb-light>.zio-rgb__kirp>canvas{position:absolute;top:0;left:0;display:block}'
      + 'zio-rgb-cizgi{left:0;right:0;overflow:hidden}'
      + 'zio-rgb-cizgi>canvas{display:block;width:100%;height:100%}'
      + '@media (prefers-reduced-motion:reduce){zio-rgb-light,zio-rgb-cizgi{display:none}}';
    document.head.appendChild(st);
  }
  function yeniTuval(parent) { var tv = document.createElement('canvas'); parent.appendChild(tv); return tv; }
  /* Gecikmeli ölçüm YERLEŞİM TEMİZKEN: geçici ResizeObserver, ilk bildirimini bir sonraki karede stil + yerleşim adımının hemen ardından
     verir (başka betik araya giremez); ölçüm orada yapılır, sonra gözlemci kapanır. Kopmuş öğede hiçbir şey çalışmaz (geçici gözlemciler
     kopunca kapatılır). ResizeObserver yoksa ölçüm hemen yapılır. */
  function temizOlc(el, f) {
    if (typeof ResizeObserver !== 'function') { f(); return; }
    var ro = new ResizeObserver(function () { ro.disconnect(); el.geciciSil(ro); if (el.zioOn) f(); });
    el.geciciler.push(ro);
    ro.observe(el.root);
  }

  /* ---------- ortak öğe davranışı ---------- */
  class ZioRgbTemel extends HTMLElement {
    connectedCallback() {
      if (this.zioOn || reduce.matches || !this.parentElement) return;
      this.root = this.parentElement;
      if (!this.hazirla()) return;
      this.zioOn = true;
      this.geciciler = [];
      this.kimlik = 'z' + (++sayac);
      this.visible = false; this.built = false; this.oynuyor = false; this.kip = null; this.motor = null; this.olcu = null; this.veri = null;
      stilKur();
      var self = this;
      this.gorunurluk = function () { if (document.hidden) self.gonder({ tip: 'durdur' }); else if (self.visible && self.oynuyor) self.gonder({ tip: 'oynat' }); };
      document.addEventListener('visibilitychange', this.gorunurluk);
      if (typeof ResizeObserver === 'function') {
        this.ro = new ResizeObserver(function (entries) {
          var cr = entries[entries.length - 1].contentRect, w = Math.round(cr.width), h = Math.round(cr.height);
          if (self.olcu && self.olcu[0] === w && self.olcu[1] === h) return;
          self.olcu = [w, h];
          clearTimeout(self.rt);
          self.rt = setTimeout(function () { temizOlc(self, function () { if (self.built) self.build(); }); }, 200);
        });
        this.ro.observe(this.root);
      }
      if (typeof IntersectionObserver === 'function') {
        this.io = new IntersectionObserver(function (entries) { self.visible = entries[entries.length - 1].isIntersecting; if (self.visible) self.play(); else self.pause(); }, { rootMargin: '80px 0px' });
        this.io.observe(this.root);
        bostaKur(function () { if (self.zioOn && !self.built && !self.visible) self.build(); });
      } else {
        this.visible = true;
        this.play();
      }
    }
    disconnectedCallback() {
      if (!this.zioOn) return;
      if (this.ro) this.ro.disconnect();
      if (this.io) this.io.disconnect();
      clearTimeout(this.rt);
      clearTimeout(this.kt);
      for (var g = 0; g < this.geciciler.length; g++) this.geciciler[g].disconnect();
      this.geciciler = [];
      document.removeEventListener('visibilitychange', this.gorunurluk);
      this.temizle();
      this.gonder({ tip: 'durdur' });
      this.gonder({ tip: 'sil' });
      delete dinleyiciler[this.kimlik];
      this.tuvalKaldir();
      this.classList.remove('is-on');
      this.ro = null; this.io = null; this.motor = null; this.kip = null; this.veri = null; this.built = false; this.oynuyor = false; this.visible = false; this.zioOn = false;
    }
    build() {
      var g = this.geometri();
      this.built = !!g;
      if (!g) return;
      this.veri = g;
      this.yerlestir();
      if (!this.kip) this.baslat(); else this.gonder({ tip: 'geo', veri: g });
    }
    gonder(m) {
      m.id = this.kimlik;
      if (this.kip === 'isci' && isci) isci.postMessage(m);
      else if (this.kip === 'yerel' && this.motor) this.motor.al(m);
    }
    /* Önce paylaşımlı işçi (OffscreenCanvas); olmazsa ya da işçi '2d' bağlam alamazsa ana iş parçacığında çizim */
    baslat() {
      var w = isciAl(), tv = this.tuval, off = null;
      if (w && tv && typeof tv.transferControlToOffscreen === 'function') {
        try {
          off = tv.transferControlToOffscreen();
          this.kip = 'isci';
          this.setAttribute('data-kip', 'isci');
          dinleyiciler[this.kimlik] = this;
          w.postMessage({ tip: 'kur', id: this.kimlik, canvas: off, veri: this.veri }, [off]);
          return;
        } catch (e) { delete dinleyiciler[this.kimlik]; }
      }
      this.yerel(!!off);
    }
    isciMesaj(m) { if (m.tip === 'yok') this.yerel(true); }
    yerel(tuvalYenile) {
      delete dinleyiciler[this.kimlik];
      if (tuvalYenile || !this.tuval) this.tuvalYenile();
      this.kip = 'yerel';
      this.setAttribute('data-kip', 'yerel');
      var self = this;
      this.motor = paket.motorKur(function (m) { if (m.tip === 'yok') { self.kip = 'yok'; self.setAttribute('data-kip', 'yok'); } });
      this.motor.al({ tip: 'kur', id: this.kimlik, canvas: this.tuval, veri: this.veri });
      if (this.oynuyor) this.gonder({ tip: 'oynat' });
    }
    geciciSil(ro) { var i = this.geciciler.indexOf(ro); if (i >= 0) this.geciciler.splice(i, 1); }
    /* Görünür olunca: kurulu değilse kur; kuruluysa 250 ms sonra, yerleşim temizken (ucuz) ölçüleri doğrula */
    play() {
      if (!this.built) this.build();
      else { var k = this; clearTimeout(this.kt); this.kt = setTimeout(function () { temizOlc(k, function () { if (k.built && k.visible) k.kontrol(); }); }, 250); }
      this.oynuyor = true;
      this.gonder({ tip: 'oynat' });
      var self = this;
      requestAnimationFrame(function () { if (self.visible) self.classList.add('is-on'); });
    }
    pause() {
      this.oynuyor = false;
      this.gonder({ tip: 'durdur' });
      this.classList.remove('is-on');
    }
    kontrol() {}
    temizle() {}
  }

  /* ---------- kart / düğme ışığı ---------- */
  class ZioRgbLight extends ZioRgbTemel {
    hazirla() {
      this.secici = this.getAttribute('data-kartlar') || '.card-grid > .card';
      var ilk = null;
      try { ilk = this.root.querySelector(this.secici); } catch (e) { ilk = null; }
      if (!ilk) return false;
      this.pay = sinir(this.getAttribute('data-pay'), 0, 64, 16);
      this.turn = sinir(this.getAttribute('data-turn'), 800, 8000, 3000);
      this.tail = sinir(this.getAttribute('data-tail'), 20, 240, 120);
      this.kalin = sinir(this.getAttribute('data-kalinlik'), 30, 100, 100) / 100;
      this.kutu = null; this.kaydirmali = false; this.kutular = null;
      var self = this;
      this.kaydir = function () { if (self.tuval && self.kaydirmali && self.kutu) self.tuval.style.transform = 'translate3d(' + (-self.kutu.scrollLeft) + 'px, 0, 0)'; };
      this.kirp = document.createElement('div');
      this.kirp.className = 'zio-rgb__kirp';
      this.appendChild(this.kirp);
      this.tuval = yeniTuval(this.kirp);
      return true;
    }
    kartlar() { return Array.prototype.filter.call(this.root.querySelectorAll(this.secici), function (el) { return el.offsetParent !== null; }); }
    /* Kartlar üst öğeye göre ölçülür (offsetParent zinciri); yılan sırasına dizilir; dizin = seçicinin verdiği sıra */
    measure() {
      var root = this.root;
      var items = yilanSirasi(this.kartlar().map(function (el, i) {
        var p = konumRoot(el, root);
        return { el: el, dizin: i, x: p.x, y: p.y, w: el.offsetWidth, h: el.offsetHeight, r: parseFloat(getComputedStyle(el).borderTopLeftRadius) || 0 };
      }));
      items.forEach(function (it) { it.kenar = kenar(it); });
      return items;
    }
    /* Kartları taşıyan, yatay kayan ata (üst öğeye kadar); yoksa null */
    kaydirmaKutusu(cards) {
      var n = cards.length ? cards[0].el.parentElement : null, root = this.root;
      while (n && n !== root) { var cs = getComputedStyle(n); if (cs.overflowX === 'auto' || cs.overflowX === 'scroll') return n; n = n.parentElement; }
      return null;
    }
    /* Geometri: yol noktaları + birikimli uzunluk; tuval kutusu = kartların kutusu ± pay; piksel oranı ≤ 2 ve ≤ 4 Mpx;
       hız = ortalama çevre / tur süresi; kırpma kutusu = kaydırma kutusu (dikeyde ± pay) ya da tuval kutusu */
    geometri() {
      var cards = this.measure(), root = this.root, pay = this.pay;
      if (!cards.length) return null;
      this.kutular = cards.map(function (c) { return [c.x, c.y, c.w, c.h]; });
      var p = yol(cards);
      var pts = p.map(function (q) { return { x: +q.x.toFixed(2), y: +q.y.toFixed(2) }; });
      var cum = [0], i;
      for (i = 1; i < pts.length; i++) cum.push(+(cum[i - 1] + Math.hypot(pts[i].x - pts[i - 1].x, pts[i].y - pts[i - 1].y)).toFixed(3));
      var minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity, Pm = 0;
      cards.forEach(function (c) { minX = Math.min(minX, c.x); minY = Math.min(minY, c.y); maxX = Math.max(maxX, c.x + c.w); maxY = Math.max(maxY, c.y + c.h); Pm += c.kenar.P; });
      Pm /= cards.length;
      minX -= pay; minY -= pay; maxX += pay; maxY += pay;
      var w = maxX - minX, h = maxY - minY;
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      if (w * h * dpr * dpr > 4e6) dpr = Math.max(1, Math.sqrt(4e6 / (w * h)));
      this.setAttribute('data-sira', p.sira.map(function (k) { return cards[k].dizin; }).join(','));
      this.setAttribute('data-halka', p.halka ? '1' : '0');
      var kutu = this.kaydirmaKutusu(cards);
      if (kutu !== this.kutu) {
        if (this.kutu) this.kutu.removeEventListener('scroll', this.kaydir);
        this.kutu = kutu;
        if (kutu) kutu.addEventListener('scroll', this.kaydir, { passive: true });
      }
      var kirp;
      if (kutu) { var kp = konumRoot(kutu, root); kirp = { x: kp.x, y: kp.y - pay, w: kutu.offsetWidth, h: kutu.offsetHeight + 2 * pay, kaydirmali: true }; }
      else kirp = { x: minX, y: minY, w: w, h: h, kaydirmali: false };
      var total = cum[cum.length - 1];
      return {
        tip: 'isik',
        geo: { pts: pts, cum: cum, total: total },
        st: { ox: minX, oy: minY, w: w, h: h, dpr: +dpr.toFixed(3), tail: this.tail, kalin: this.kalin, hiz: Pm / (this.turn / 1000), periyot: total },
        kirp: kirp
      };
    }
    yerlestir() {
      var v = this.veri, tv = this.tuval, kk = v && v.kirp;
      if (!tv || !kk || !this.kirp) return;
      this.kirp.style.left = kk.x + 'px';
      this.kirp.style.top = kk.y + 'px';
      this.kirp.style.width = kk.w + 'px';
      this.kirp.style.height = kk.h + 'px';
      tv.style.left = (v.st.ox - kk.x) + 'px';
      tv.style.top = (v.st.oy - kk.y) + 'px';
      tv.style.width = v.st.w + 'px';
      tv.style.height = v.st.h + 'px';
      this.kaydirmali = kk.kaydirmali;
      this.setAttribute('data-kaydirmali', kk.kaydirmali ? '1' : '0');
      tv.style.transform = kk.kaydirmali && this.kutu ? 'translate3d(' + (-this.kutu.scrollLeft) + 'px, 0, 0)' : '';
    }
    /* Kart kutuları kurulumdakiyle aynı mı (0,5 px); değilse yeniden ölç */
    kontrol() {
      var cards = this.measure(), k = this.kutular;
      if (!k || cards.length !== k.length) { this.build(); return; }
      for (var i = 0; i < cards.length; i++) { var c = cards[i], b = k[i]; if (Math.abs(c.x - b[0]) > 0.5 || Math.abs(c.y - b[1]) > 0.5 || Math.abs(c.w - b[2]) > 0.5 || Math.abs(c.h - b[3]) > 0.5) { this.build(); return; } }
    }
    temizle() { if (this.kutu) this.kutu.removeEventListener('scroll', this.kaydir); this.kutu = null; this.kaydirmali = false; }
    tuvalYenile() {
      var eski = this.tuval;
      this.tuval = yeniTuval(this.kirp);
      if (eski && eski.parentNode === this.kirp) this.kirp.removeChild(eski);
      this.yerlestir();
    }
    tuvalKaldir() { if (this.kirp && this.kirp.parentNode === this) this.removeChild(this.kirp); this.kirp = null; this.tuval = null; }
  }

  /* ---------- çubuk çizgisi ---------- */
  class ZioRgbCizgi extends ZioRgbTemel {
    hazirla() {
      this.kalinPx = sinir(this.getAttribute('data-kalinlik'), 1, 4, 2);
      this.kayma = sinir(this.getAttribute('data-kayma'), 4, 20, 8);
      this.konum = this.getAttribute('data-konum') === 'ust' ? 'ust' : 'alt';
      this.style.height = this.kalinPx + 'px';
      this.style.top = this.konum === 'ust' ? '0' : 'auto';
      this.style.bottom = this.konum === 'ust' ? 'auto' : '0';
      this.tuval = yeniTuval(this);
      return true;
    }
    /* Ölçü: genişlik = öğenin (yoksa üst öğenin) iç genişliği, yükseklik = kalınlık; hız = desen / kayma süresi */
    geometri() {
      var w = this.clientWidth || this.root.clientWidth, h = this.kalinPx;
      if (!(w > 0) || !(h > 0)) return null;
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      return { tip: 'cizgi', st: { w: w, h: h, dpr: +dpr.toFixed(3), hiz: paket.DESEN / this.kayma, periyot: paket.DESEN } };
    }
    yerlestir() {}
    tuvalYenile() { var eski = this.tuval; this.tuval = yeniTuval(this); if (eski && eski.parentNode === this) this.removeChild(eski); }
    tuvalKaldir() { if (this.tuval && this.tuval.parentNode === this) this.removeChild(this.tuval); this.tuval = null; }
  }

  customElements.define('zio-rgb-light', ZioRgbLight);
  customElements.define('zio-rgb-cizgi', ZioRgbCizgi);
})();
